export default __webpack_public_path__ + "static/kynnet6-99de404a354d5ece84d1e27421d7c83f.jpeg";